import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaTimesCircle,FaCheck,FaTimes     } from "react-icons/fa";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import { Container, Row, Col } from "react-bootstrap";
import len from '../../assets/svg/lentra.svg'
import profile from '../../assets/svg/profile.svg'
import production from '../../assets/svg/production.svg'
import check_failed from '../../assets/svg/druken.svg'
import temp from '../../assets/svg/temp.svg'
import add from '../../assets/svg/add.svg'
import nandhu from '../../assets/svg/nandhu.svg'
import { ReactComponent as ItemNameIcon } from "../../assets/svg/itemname.svg";
import { ReactComponent as QuantityIcon } from "../../assets/svg/Quantity.svg";
import { ReactComponent as DescriptionIcon } from "../../assets/svg/Description.svg";
import { ReactComponent as MoreIcon } from "../../assets/svg/more.svg";
import phone from '../../assets/svg/ph.svg'
import "./gate-out-modal.css";
import AddItemModal from "./add-item-modal";
import sampleProfile from '../../assets/png/customer-icon.png'
import { getCheckList, getResponsiblePersonApi, getVisitorDetailsApi, queueStatusUpdateApi } from "../visitor/visitor-api.js";
import { ReactComponent as TickIcon } from "../../assets/svg/tick.svg";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import DOMPurify from 'dompurify';
import CheckListFailedModal from "./checklist-failed-modal.js";
import CheckListFailedAdminModal from "./checklist-failed-admin-modal.js";
import { getVehicleDetailsApi } from "../vehicle/vehicle-api.js";

 const QueueApproveModal = ({fromModule, visitorDetails,onApproveQueue, onApproveQueueAndGateIn, onCancel, }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [alertItemIndex, setAlertItemIndex] = useState(null);
      const [showAddItemModal, setAddItemModal] = useState(false);
  const [itemData, setItemData] = useState(null);
   const [itemList, setItemList] = useState([]); 
   const [checkList, setCheckList] = useState([]);
  const [errorCheckList, setErrorCheckList]=useState([]);  
    const [showChecklistFailedModal, setChecklistFailedModal] = useState(false);
    const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] = useState(false);
      const [responsiblePerson,setResponsiblePerson] =useState("");
      const [loginPerson,setLoginPerson] =useState({});
      const [statusApproveGateIn,setStatusApproveGateIn] =useState("");

    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "1000px",
          height:"500px",
          overflowY: "auto",
          overflowX:'hidden'
        },
      };

  useEffect(() => {
    setVisitorData(visitorDetails)
    if(fromModule==="Visitor"){
      getVisitorDetails();
    }

    if(fromModule==="Vehicle"){
      getVehicleDetails();
    }
    
    getResponsiblePerson();
    
      getCheckListData(fromModule)
   
    
  },[visitorDetails]);

  const [visitorData, setVisitorData] = useState({});
   
    
    const [validations, setValidations] = useState({
      "meeting_person":"",
      "checklists": [],
      "items": [],
          });
  const [meetingPersonOption, setMeetingPersonOption] = useState(null);
          const handleMeetingPersonDropdownChange = (option) => {
            console.log(option)
            setMeetingPersonOption(option)
          };

      const alertRef = useRef(null);
         useEffect(() => {
           // Attach event listener to the document
           document.addEventListener("mousedown", handleClickOutside);
           return () => {
             // Clean up event listener on unmount
             document.removeEventListener("mousedown", handleClickOutside);
           };
         }, []);
         const handleClickOutside = (event) => {
           if (alertRef.current && !alertRef.current.contains(event.target)) {
             setAlertItemIndex(null); // Close the alert
           }
         };    
         const onSaveItem=(itemData)=>{
          setAddItemModal(false);
          const tempItem=[...itemList];
          if(itemData.index===null){
          tempItem.push(itemData.item)
          }else{
            tempItem[itemData.index]=itemData.item;
          }
          setItemList(tempItem)
          }  

            const getVisitorDetails = async () => {
              try {
                const response = await getVisitorDetailsApi(visitorDetails.id);
                if (response.status === true) {
                  setVisitorData(response.visitor ?? {})
                }
                return response.data;
              } catch (err) {
                console.error("Error fetching category:", err);
              } finally {
              }
            };

            const getVehicleDetails = async () => {
              try {
                const response = await getVehicleDetailsApi(visitorDetails.id);
                if (response.status === true) {
                  setVisitorData(response.vehicle ?? {})
                }
                return response.data;
              } catch (err) {
                console.error("Error fetching category:", err);
              } finally {
              }
            };

           const getResponsiblePerson = async () => {   
              try {
                const response = await getResponsiblePersonApi(visitorDetails.gate_id);
                if (response.success === true) {
                setResponsiblePerson(response.responsible_person);
                setLoginPerson(response?.employee ??'')
                }
            return response.data;
              } catch (err) {
                console.error("Error fetching category:", err);
              } finally {
              }
            };

            const getCheckListData = async (type) => {
             
              try {
                const response = await getCheckList(visitorDetails.location_id,type);
                if (response.success === true) {      
                setCheckList(response.suggestionlist);
                }
            return response.data;
              } catch (err) {
                console.error("Error fetching category:", err);
              } finally {
              }
            };
           /*  const getVehicleCheckListData = async () => {
             
              try {
                const response = await getVehicleCheckList(visitorData.id);
                if (response.success === true) {      
                setCheckList(response.suggestionlist);
                }
            return response.data;
              } catch (err) {
                console.error("Error fetching category:", err);
              } finally {
              }
            }; */
            

  useEffect(() => {
      if(errorCheckList.length>0){
        console.log(loginPerson)
        console.log(responsiblePerson)
        if(responsiblePerson===loginPerson.id){
          setChecklistFailedAdminModal(true)
        }else{
          setChecklistFailedModal(true)
        }
        
      }      
     },[errorCheckList])
     
     const onProceedCheckList=()=>{
      setChecklistFailedModal(false);
      setChecklistFailedAdminModal(false);
      queueStatusUpdate(false,'pending',statusApproveGateIn)

    }
    const onApprovedCheckList=()=>{
      setChecklistFailedAdminModal(false);
      queueStatusUpdate(false,'approve',statusApproveGateIn)
    }

            const queueStatusUpdate = async (queueCheckvalidate,queueCheckListStatus, status) => {
              setStatusApproveGateIn(status)
             const payload = {
                "id": visitorData.id,
                 "status": status,
                 "meeting_person":meetingPersonOption!=null? meetingPersonOption.value:"",
                "checklists": checkList.map((check) => ({
                             "id": DOMPurify.sanitize(check.id),
                             "value": DOMPurify.sanitize(check.inputvalue?.toString())
                        })),
                "queue_status": 'Approved', // Approved, Rejected
                "validate_check_list": queueCheckvalidate,// true, fasle
                "check_list_status": queueCheckListStatus,//pending, approve
                "type": fromModule.toLowerCase(), // pending, approved, rejected
                "items": itemList.map((item) => ({
                              "item_name": DOMPurify.sanitize(item.item_name),
                              "quantity": DOMPurify.sanitize(item.quantity),
                              "description": DOMPurify.sanitize(item.description)
                          }))
              };
              try {
                const response = await queueStatusUpdateApi(payload);
                if (response.statusCode === 400) {
                  new Promise((resolve, reject) => {  
                                           
                           const validationTemp = {
                 "meeting_person":"",
                "checklists": "",
                "items": "",
                          };
                           Object.entries(response.data.error).forEach(([key, value]) => {
                            console.log(`${key}: ${value}`);
                            if(key==="checklists"){
                             /*  validationTemp[key]=value; */
                             validationTemp[key]=value.length===0?'':value[0];
                            }else{
                              validationTemp[key]=value.length===0?'':value[0];
                            }
                           
                          });
                          console.log('validationTemp...',validationTemp);
                           setValidations(validationTemp);
                      }); 
                }
                else{
                      if(response.data.status===true){
                        if(statusApproveGateIn==='gate-in'){
                          onApproveQueueAndGateIn(response.data)    
                        }else{
                          onApproveQueue(response.data)   
                        }
                      }else{
                              if (response.status === 402) {
                                setErrorCheckList(response.data.error)
                                } 
                            }
                }
            return response.data;
              } catch (err) {
                console.error("Error fetching category:", err);
              } finally {
              }
            };

            

    return ( <div style={modalStyle.overlay}>
       {showAddItemModal && <AddItemModal itemData={itemData} onSave={onSaveItem} onCancel={() =>{setAddItemModal(false);setItemData(null)}} />}
         {showChecklistFailedModal && <CheckListFailedModal  checkList={errorCheckList} loginPerson={loginPerson} onSave={onProceedCheckList} onCancel={() =>{setChecklistFailedModal(false);}} />}
              {showChecklistFailedAdminModal && <CheckListFailedAdminModal  checkList={errorCheckList} moduleName={fromModule} visitorName={visitorData.visitor_name} organization={visitorData.organization} visitorPicture={visitorData.profilephoto??''} isSaveEnable={true} onSave={onProceedCheckList} isApprovedEnable={true} onApproved={onApprovedCheckList} onCancel={() =>{setChecklistFailedAdminModal(false);}} />}
        <div style={modalStyle.modal}>
          
          <div >
            <div className="modal-header style-justify-between"
            >
              <div className="modal-title"
    >
    Check List
    </div>
    <img
                              src={ModalCloseIcon}
                              alt="Close"
                              onClick={onCancel}
                              style={{ cursor: "pointer",width: "30px", height: "30px", borderRadius: "50%" }}
                            />
      
            </div>
{/* Profile */}
<div className=" px-2">
<div className="style-justify-between">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src={visitorData.profilephoto!=null && visitorData.profilephoto!==''?visitorData.profilephoto:sampleProfile}
                              alt="Profile"
                              style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                            />
                            <div>
                              <div className="visitor-name">
                              {visitorData.visitor_name??''} {visitorData.driver_name??''}
                              </div>
                             {fromModule==="Visitor" && (<div><img src={len} alt=""/> <span className="org-title">{visitorData.organization}</span>
                              </div>)} 

                              {fromModule==="Vehicle" && (<div style={{ display: "flex", alignItems: "center",}}>
                  <div className="field-title pt-1">{visitorData.vehicle_number}</div> <span className="dot-span mx-2"></span> <div className="vehicle-type-card px-2 pt-1">{visitorData.vehicle_type}</div>
                </div>)}

                            </div>
                          </div>
                          <div style={{padding:'6px 12px', borderRadius:'16px', backgroundColor:'#EDFFF4'}}>
                          <img src={phone} alt=""/> <span className="font-13-600">{visitorData.mobile_number}</span>
                          </div>
                          </div>
                        {fromModule==="Visitor" && (<Row className=" px-2">
                            <Col sm={12} lg={6} className="mt-3">
                                                  <div className="field-title">Meeting person by visitor</div>
                                                  <div className="mt-1">
                                                    <div>
                                                      <input
                                                        type="text"
                                                        placeholder="Enter here"
                                                        className="input-field w-100"
                                                        value={visitorData.meeting_person_name??''}
                                                        readOnly={true}
                                                      />
                                                      <span style={{display: "flex", alignItems: "center", justifyContent: "start",fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.meeting_person_name}</span>
                                                    </div>                       
                                                  </div>
                                                </Col>
                            <Col sm={12} lg={6} className="mt-3">
                                                  <div className="field-title">Meeting person</div>
                                                  <div className="mt-1">
                                                    <div>
                                                    <SearchWithAPI onDropdownChange={handleMeetingPersonDropdownChange} apiUrl={apiUrl+"get_meeting_person"} params={{}} placeholder={"Select"} selectedOption={meetingPersonOption}/>
                                                    <span style={{display: "flex", alignItems: "center", justifyContent: "start",fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.meeting_person}</span>
                                                    </div>                       
                                                  </div>
                                                </Col>
                          </Row>)}  
                         
             <div className="mt-2" style={{ display: "flex",  }}>
                        {/* Left Section */}
                        <div
                          style={{
                            width: "40%",
                            background: "#fff",
                            borderRadius: "12px",
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                            
                           
                          }}
                        >
                          
                        
               <div className="card-view mt-2">
                                <div className="card-title">Check list </div>
                                
                                <div className="mt-2" style={{gap:'8px', height:'180px', overflowY:'scroll',  }}>
                                {checkList.map((check, index) =>{
                                 if (check.inputvalue==null){
                                  check["inputvalue"]="";
                                 }  
                                  return (
                                    <div key={"checklist"+index}  className=" mb-2">
                                  <div className="check-list style-justify-between">
                                    <div>{check.checkname}</div>
                                   {check.creteria !=="Boolean" && ( <div >
                                    <input
                                          style={{ width: "100px" }}
                                          type="text"
                                          placeholder={check.checkname}
                                          className="input-field"                           
                                          value={check.inputvalue}
                                          onChange={(event) => {  
                                            const value = event.target.value.replace(
                                              /\D/g,
                                              ""
                                            );   
                                              const tempChecklist=[...checkList];
                                              tempChecklist[index]["inputvalue"]=value
                                              setCheckList(tempChecklist)
                                          }}
                                        />
                                    </div>)}
              
                                    {check.creteria ==="Boolean" && (<div className="style-justify-start" style={{gap:'8px'}}>
                                      <div className={`checklist-bool style-justify-start ${check.inputvalue ? "active-bool-btn" : ""}`} onClick={()=>{
                                        const tempChecklist=[...checkList];
                                        tempChecklist[index]["inputvalue"]=true
                                        setCheckList(tempChecklist)
                                      }}>
                                    <FaCheck style={{ color: check.inputvalue ?'white':'#172B4D' }} />   <div style={{paddingLeft:'8px'}}> Yes</div>
                                      </div>
                                      <div className={`checklist-bool style-justify-start ${check.inputvalue===false ? "in-active-bool-btn" : ""}`} onClick={()=>{
                                        const tempChecklist=[...checkList];
                                        tempChecklist[index]["inputvalue"]=false
                                        setCheckList(tempChecklist)
                                      }}>
                                        <FaTimes  style={{ color: check.inputvalue===false ?'white':'#172B4D' }} />
                                       
                                     <div style={{paddingLeft:'8px'}}> No</div>
                                      </div>
                                    </div>)}
                                  </div>
                                  <span style={{display: "flex", alignItems: "center", justifyContent: "start",fontSize: "12px",fontWeight: 400,color: "#FF4444", }}>{validations.checklists}</span>
                                  </div>
                                );
                              }
                                ) }      
                                </div>
                              </div>
                          
                         
                        </div>
                        
              
                        {/* Right Section */}
                        <div
                          style={{
                            width: "60%",
                            background: "#fff",
                           
                            padding: "12px",
                            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                         
                          {/* Carrying Items */}
                          <div className="font-15-700 mt-1 mb-1">Carrying Items</div>
                          
                           <div className="item-list-header" style={{flex:'12', marginRight:'16px'}}>
                                               
                                                      <span className="item-list-header-txt style-justify-start" style={{flex:'4'}}><ItemNameIcon style={{marginRight:'8px'}}/>Item Name</span>
                                                      <span className="item-list-header-txt style-justify-start" style={{flex:'3'}}><QuantityIcon style={{marginRight:'8px'}}/>Quantity</span>
                                                      <span className="item-list-header-txt style-justify-start" style={{flex:'5'}}><DescriptionIcon style={{marginRight:'8px'}}/>Description</span>
                                                     
                                                  </div>
                                                  <div style={{height:'180px', overflowY:'scroll'}}>
                                                  {visitorData?.itemList?.map((item, index) => (
                                                                <div key={'item-list'+index}>
                                                                  
                                                  <               div className="item-list-row" style={{flex:'12',}}>
                                                                       
                                                                       <span className="item-list-row-txt" style={{flex:'4'}}>{item.item_name}</span>
                                                                       <span className="item-list-row-txt" style={{flex:'3'}}>{item.quantity}</span>
                                                                       <div className="item-list-row-txt" style={{flex:'5', position: "relative"}} >
                                                                       <span >{item.description}</span>
                                                                       
                                                                       </div>
                                                                      
                                                                   </div>
                                                                </div> ))}
                                                                {itemList?.map((item, index) => (
                                                                <div key={'item-list'+index}>
                                                                  
                                                  <               div className="item-list-row" style={{flex:'12',}}>
                                                                       
                                                                       <span className="item-list-row-txt" style={{flex:'4'}}>{item.item_name}</span>
                                                                       <span className="item-list-row-txt" style={{flex:'3'}}>{item.quantity}</span>
                                                                       <div className="item-list-row-txt" style={{flex:'5', position: "relative"}} >
                                                                       <span >{item.description}</span>
                                                                       <div style={{ position: "absolute",position:'absolute',top: "5px", right: "5px",  }}>
                                                                        <div style={{ position: "relative" }}>
                                                                       <MoreIcon style={{cursor:'pointer'}} onClick={()=>{setAlertItemIndex(index === alertItemIndex ? null : index);}}/>
                                                                       {alertItemIndex === index && (
                                                                                       <div ref={alertRef} style={{ position: "absolute",
                                                                                        top: "40px",
                                                                                        left: "50%",
                                                                                        transform: "translateX(-50%)",
                                                                                        backgroundColor: "#ffffff",
                                                                                        color: "#1E1E1E",
                                                                                        padding: "16px",
                                                                                        borderRadius: "16px",
                                                                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                                                        zIndex: 1,alignItems:'end', }}>
                                                                                        <div onClick={()=>{setItemData({"item":item,"index":index});setAddItemModal(true);setAlertItemIndex(null)}} style={{cursor: "pointer",width:'150px', height:'36px', fontSize:"14px", fontWeight:"500",  color: '#1E1E1E',display: 'flex',alignItems:'center',justifyContent:'start'}} >
                                                                                        Edit
                                                                              </div>
                                                                              <div onClick={()=>{
                                                                                const tempItems=[...itemList];
                                                                                tempItems.splice(index,1);
                                                                                setItemList(tempItems)
                                                                                setAlertItemIndex(null)
                                                                              }}  style={{cursor: "pointer",width:'150px',height:'36px', fontSize:"14px", fontWeight:"500", color: '#1E1E1E', display: 'flex',alignItems:'center',justifyContent:'start'}} >
                                                                              Delete
                                                                              </div>
                                                                                       </div>
                                                                                     )}
                                                                       </div>
                                                                       </div>
                                                                       </div>
                                                                      
                                                                   </div>
                                                                </div> ))}
                                                                </div>
                        
              
                          {/* Buttons */}
                          <button className="mt-2"
                            style={{
                              background: "none",
                              color: "#166534",
                              border: "1px solid #E5E5E5",
                              padding: "6px 12px",
                              borderRadius: "5px",
                              cursor: "pointer",
                              marginRight: "10px",
                            }}
                            onClick={() => {
                              setAlertItemIndex(null)
                              setAddItemModal(true);
                            }}
                          >
                            <img src={add} alt=""/> <span className="font-13-700-2C8C53">Add item</span>
                          </button>
              
                          <Row className="mt-3"                
              >
                <div className="style-justify-end">
                <div
                  onClick={onCancel} className="admin-checklist-cancel-btn style-justify-center"                  
                >
                 Cancel
                </div>

               <div
                   onClick={()=>{queueStatusUpdate(true,'pending','')}} className="checklist-approve-btn style-justify-center"                  
                >
                 Approve
                </div>

                <div className="checklist-approve-gatein-btn style-justify-center"
                  onClick={()=>{queueStatusUpdate(true,'pending','gate-in')}}>
                 Approve & Gate-In
                </div>
                
                </div>
              </Row>
                        </div>
                      </div>
          </div>
        </div>
        </div>
      </div>);

}

export default QueueApproveModal;